import React, { useRef, useState } from "react";
import { Card } from "./components/ui/card";
import { Button } from "./components/ui/button";
import Layout from "./Layout";
import contactHero from './assets/contact_hero.jpg';
import emailjs from "@emailjs/browser";

export default function Contact() {
  const form = useRef();
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      "service_zcm21hm",   // Your Service ID
      "template_f0ujzvo",  // Your Template ID
      form.current,
      "EEpj2TOz4FqwpyERM"  // Your Public Key
    ).then(
      (result) => {
        console.log(result.text);
        setStatus("Message sent successfully!");
        form.current.reset();
      },
      (error) => {
        console.log(error.text);
        setStatus("Failed to send message. Try again.");
      }
    );
  };

  return (
    <Layout>
      {/* Hero Section */}
      <div className="relative rounded-xl overflow-hidden shadow-lg h-[300px] mb-8">
        <img src={contactHero} alt="Contact" className="w-full h-full object-cover"/>
        <div className="absolute inset-0 bg-black/30 flex items-center justify-center text-white text-xl font-bold">
          Contact / Schedule a Demo
        </div>
      </div>

      {/* Contact Form */}
      <Card className="rounded-xl shadow-lg max-w-xl mx-auto p-6">
        <form ref={form} onSubmit={sendEmail} className="space-y-4">
          <input
            name="name"
            className="w-full border p-2 rounded-lg"
            placeholder="Your Name"
            required
          />
          <input
            name="email"
            type="email"
            className="w-full border p-2 rounded-lg"
            placeholder="Your Email"
            required
          />
          <input
            name="phone"
            className="w-full border p-2 rounded-lg"
            placeholder="Your Phone Number"
          />
          <input
            name="company"
            className="w-full border p-2 rounded-lg"
            placeholder="Company"
          />
          <textarea
            name="message"
            className="w-full border p-2 rounded-lg"
            placeholder="Your Message"
            rows={4}
            required
          />
          <Button type="submit" className="bg-primary hover:bg-secondary text-white px-6 py-3 rounded-lg">
            Send
          </Button>
          {status && <p className="mt-2 text-sm text-gray-700">{status}</p>}
        </form>
      </Card>
    </Layout>
  );
}